import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { MenuQuery } from './../queries';
import { Language, Menu } from './../data';

@Injectable()
export class MenuService {
  private mRoot: Observable<Menu>;

  constructor() {

  }

  public root() {
    if (!this.mRoot) {
      this.mRoot = new MenuQuery().equalTo(Menu.NAME_KEY, Menu.ROOT_NAME).rx().first();
    }
    return this.mRoot;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/menu-service.ts